module.exports = __webpack_public_path__ + "img/v10.7.112cd7a0.png";